export * from './rubrique-selector';
